import React, { useEffect } from 'react';
import '../cs/temp.css';
import '../cs/te.css';
import AOS from "aos";
import "aos/dist/aos.css";

function DataAnalytics() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, [])
  return (
    <div className="webdev-page" style={{ overflowX: "hidden" }}>
      {/* Banner */}
      <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container" data-aos="fade-up">
            <div className="inner-banner-content">
              <h1 className="inner-title">Data Analytics </h1>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section analytics-intro">
        <div className="container">
          <div className="intro-content">
            <div className="section-header text-left">
              <h2 data-aos="fade-up">Transform Data into Business Value</h2>
              <p className="intro-text">
                At Codenix Infotech, we harness the power of AI and Machine Learning to deliver cutting-edge data analytics solutions. Our expert data scientists develop customized tools to help businesses unlock insights, automate decision-making, and drive growth.            </p>
            </div>

          </div>
          <div className="intro-image analytics-graphic">
          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="webdev-services-section analytics-services">
        <div className="container">
          <div className="section-header">
            <h2>Our Data Analytics Services</h2>
            <p className="section-description">
              Comprehensive data solutions to unlock insights and drive strategic decision-making
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-brain"></i>
              </div>
              <h3>AI-Powered Analytics</h3>
              <p>Leverage advanced AI algorithms to extract deep insights from data, empowering informed business strategies.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-cogs"></i>
              </div>
              <h3>Machine Learning Models</h3>
              <p>Develop predictive ML models to understand customer behavior, optimize operations, and forecast trends.
                .</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-chart-pie"></i>
              </div>
              <h3>Business Intelligence</h3>
              <p>Transform raw data into actionable intelligence with dashboards, reports, and advanced BI tools.
                .</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-database"></i>
              </div>
              <h3>Big Data Processing</h3>
              <p>Handle and analyze large volumes of structured and unstructured data to uncover meaningful patterns.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-project-diagram"></i>
              </div>
              <h3>Predictive Analytics</h3>
              <p>Use statistical modeling to forecast future trends, improve planning, and reduce business risks.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-desktop"></i>
              </div>
              <h3>Data Visualization</h3>
              <p>Build interactive dashboards and dynamic reports to make complex data easy to interpret and act upon.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Development Process Section */}
      <section className="design-process-section analytics-process">
        <div className="container">
          <div className="section-header">
            <h2>Our Data Analytics Process</h2>
            <p className="section-description">
              A structured approach to delivering intelligent and impactful data analytics solutions
            </p>
          </div>

          <div className="process-timeline">
            {[
              {
                num: 1,
                title: "Requirement Analysis",
                text: "Collaborate to define business goals, KPIs, and the scope of your analytics solution."
              },
              {
                num: 2,
                title: "Data Collection & Preparation",
                text: "Clean, structure, and preprocess your data to ensure accuracy and consistency."

              },
              {
                num: 3,
                title: "Model Development",
                text: "Design and train AI/ML models tailored to your unique data challenges and objectives."
              },
              {
                num: 4,
                title: "Testing & Validation",
                text: "Run rigorous tests to ensure model accuracy, scalability, and performance.                "
              },
              {
                num: 5,
                title: "Integration",
                text: "Seamlessly integrate analytics tools with your existing systems and workflows.                "
              },
              {
                num: 6,
                title: "Support & Optimization",
                text: "Continuously monitor, update, and refine solutions to ensure they evolve with your business.                "
              }
            ].map((step) => (
              <div className="process-step" key={step.num} data-aos="fade-up-left" data-aos-delay="200">
                <div className="step-number">{step.num}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="design-principles-section analytics-features">
        <div className="container">
          <div className="section-header">
            <h2>Key Features of Our Data Analytics Solutions</h2>
            <p className="section-description">
              What makes our data analytics services stand out from the rest
            </p>
          </div>

          <div className="services-grid">
            {[
              {
                icon: "fas fa-lightbulb",
                title: "Actionable Insights",
                text: " Transform data into clear, strategic decision-making power."
              },
              {
                icon: "fas fa-brain",
                title: "AI-Powered Analytics",
                text: "Leverage AI and ML for advanced, predictive analytics."
              },
              {
                icon: "fas fa-puzzle-piece",
                title: "Customized Solutions",
                text: "Custom-built analytics tools for your industry and needs."
              },
              {
                icon: "fas fa-bolt",
                title: "Real-Time Processing",
                text: " Access instant insights for fast, data-driven decisions."
              },
              {
                icon: "fas fa-plug",
                title: "Seamless Integration",
                text: "Designed to fit into your existing ecosystem effortlessly."
              },
              {
                icon: "fas fa-hands-helping",
                title: "Ongoing Support",
                text: "Continuous updates, maintenance, and expert support."
              }
            ].map((feature, idx) => (
              <div className="service-card" key={idx} data-aos="fade-up-left" data-aos-delay="200">
                <div className="service-icon">
                  <i className={feature.icon}></i>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section mt-5 analytics-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Unlock the Power of Your Data?</h2>
            <p>Let's create data analytics solutions that provide actionable insights and drive your business forward.</p>
            <a href="/contact" className="cta-button">Get a Free Data Analytics Consultation</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DataAnalytics;
